/**
 * useCreateEmployee — React Query mutation új HR dolgozó létrehozásához
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createEmployee, type CreateEmployeeInput, type Employee } from '../api/hr-api';
import { employeesQueryKey } from './useEmployees';

export function useCreateEmployee() {
  const queryClient = useQueryClient();

  return useMutation<Employee, Error, CreateEmployeeInput>({
    mutationFn: async (data: CreateEmployeeInput) => {
      const res = await createEmployee(data);
      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: employeesQueryKey });
    },
  });
}
